
import React, { useState } from 'react';
import Header from '@/components/Header';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { useToast } from '@/hooks/use-toast';
import PaymentForm from '@/components/PaymentForm';
import BillsHeader from '@/components/bills/BillsHeader';
import BillsTabs from '@/components/bills/BillsTabs';
import BillsSummary from '@/components/bills/BillsSummary';
import { billsData } from '@/components/bills/mockData';
import { Bill } from '@/components/bills/types';

const Bills = () => {
  const [activeTab, setActiveTab] = useState('current');
  const [searchTerm, setSearchTerm] = useState('');
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [selectedBill, setSelectedBill] = useState<Bill | null>(null);
  const { toast } = useToast();

  const handlePayNow = (bill: Bill) => {
    setSelectedBill(bill);
    setShowPaymentForm(true);
  };

  const handlePaymentComplete = () => {
    setShowPaymentForm(false);
    toast({
      title: "Payment Successful",
      description: `Your payment for ${selectedBill?.month} has been processed successfully.`,
      variant: "default",
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      <main className="pt-24 pb-10 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <BillsHeader />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            {showPaymentForm ? (
              <Card className="border-gray-200 dark:border-gray-800 shadow-sm">
                <CardHeader>
                  <CardTitle className="text-gray-900 dark:text-white">Make Payment</CardTitle>
                  <CardDescription className="text-gray-600 dark:text-gray-400">
                    Pay your bill for {selectedBill?.month}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <PaymentForm 
                    bill={selectedBill!} 
                    onPaymentComplete={handlePaymentComplete} 
                    onCancel={() => setShowPaymentForm(false)}
                  />
                </CardContent>
              </Card>
            ) : (
              <BillsTabs 
                bills={billsData}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                onPayNow={handlePayNow}
                showPaymentForm={showPaymentForm}
                selectedBill={selectedBill}
                handlePaymentComplete={handlePaymentComplete}
                setShowPaymentForm={setShowPaymentForm}
              />
            )}
          </div>
          
          <div>
            <BillsSummary />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Bills;
